// src/features/pricing/import/PriceResultStep.jsx
import React, { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Badge, Row, Col } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { useAppContext } from "providers/AppProvider";
import IconButton from "components/common/IconButton";
import { Pen, Trash } from "react-bootstrap-icons";
import EditPriceModal from "./EditPriceModal";
import { deleteInvalid, deleteRow } from "../config/PriceSlice";

const PriceResultStep = () => {
  const dispatch = useDispatch();
  const { inValidData, tableData } = useSelector((state) => state.price);
  const {
    config: { theme },
  } = useAppContext();

  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(false);

  const handleDeleteRow = (row) => {
    dispatch(deleteInvalid(row?.rowNum));
    dispatch(deleteRow(row?.rowNum));
  };
  const handleEdit = (row) => {
    setShowModal(true);
    setSelectedRow(row);
  };

  const unValidData = tableData?.filter(
    (item) => item?.isValid !== "Valid" && item?.isValid !== true
  );

  const columns = useMemo(
    () => [
      {
        name: "#",
        selector: (row, index) => index + 1,
        width: "70px",
        sortable: true,
      },

      {
        name: "Nphies Code",
        selector: (row) => row["Nphies Code"] || "-",
        sortable: true,
      },
      {
        name: "Provider Code",
        selector: (row) => row["Provider Service Code"] || "-",
        sortable: true,
      },
      {
        name: "Price",
        selector: (row) => row["Price"] ?? "-",
        sortable: true,
      },
      {
        name: "Discount",
        selector: (row) => row["Discount"] ?? "-",
        sortable: true,
      },
      {
        name: "VAT",
        selector: (row) => {
          const vat = row["VAT Indicator "];
          return isNaN(vat) ? "-" : vat;
        },
        sortable: true,
      },
      {
        name: "Status",
        cell: (row) =>
          row?.isValid === "Valid" || row?.isValid === true ? (
            <Badge bg="success">Valid</Badge>
          ) : (
            <Badge bg="danger">Invalid</Badge>
          ),
        width: "100px",
      },
    ],
    []
  );
  const InvalidColumns = useMemo(
    () => [
      {
        name: "#",
        selector: (row, index) => index + 1,
        width: "70px",
        sortable: true,
      },
      {
        name: "Nphies Code",
        selector: (row) => row["Nphies Code"] || "-",
        sortable: true,
      },
      {
        name: "Provider Code",
        selector: (row) => row["Provider Service Code"] || "-",
        sortable: true,
      },
      {
        name: "Price",
        selector: (row) => row["Price"] ?? "-",
        sortable: true,
      },
      {
        name: "Discount",
        selector: (row) => row["Discount"] ?? "-",
        sortable: true,
      },
      {
        name: "VAT",
        selector: (row) => {
          const vat = row["VAT Indicator "];
          return isNaN(vat) ? "-" : vat;
        },
        sortable: true,
      },
      {
        name: "Actions",
        cell: (row) => (
          <div className="d-flex gap-2">
            <IconButton
              size="sm"
              variant="outline-primary"
              onClick={() => handleEdit(row)}
            >
              <Pen />
            </IconButton>
            <IconButton
              size="sm"
              variant="outline-danger"
              onClick={() => handleDeleteRow(row)}
            >
              <Trash />
            </IconButton>
          </div>
        ),
        width: "150px",
      },
    ],
    []
  );

  return (
    <>
      <Row>
        {inValidData?.length > 0 && (
          <Col xs={12} className="mb-4">
            <h5 className="text-danger mb-3 fs-9">Invalid Nphies Codes</h5>
            <DataTable
              columns={InvalidColumns}
              data={inValidData}
              // pagination
              highlightOnHover
              dense
              theme={theme}
            />
          </Col>
        )}

        <Col xs={12}>
          <DataTable
            columns={columns}
            data={tableData}
            pagination
            highlightOnHover
            dense
            theme={theme}
          />
        </Col>
      </Row>
      <EditPriceModal
        show={showModal}
        onHide={() => setShowModal(false)}
        setSelectedRow={setSelectedRow}
        selectRow={selectedRow}
      />
    </>
  );
};

export default PriceResultStep;
